import React from 'react';
import { CheckIconRounded, Typography } from '@dev/ee-components';
import { useTranslation } from 'react-i18next';
import { OnboardingCardCounter, OnboardingTaskMarkupWrapper } from '../../styles';
import { OnboardingTaskMarkupProps } from '../../types';

export const OnboardingTaskMarkup = (props: OnboardingTaskMarkupProps) => {
    const { doneSteps, allSteps } = props;
    const { t } = useTranslation();
    const stepCompleted = doneSteps === allSteps;

    return (
        <OnboardingTaskMarkupWrapper>
            {stepCompleted && <Typography variant="body1">{t('completed')}</Typography>}
            <OnboardingCardCounter $isTaskCompleted={stepCompleted}>
                {stepCompleted ? (
                    <CheckIconRounded />
                ) : (
                    <Typography variant="body1">{`${doneSteps}/${allSteps}`}</Typography>
                )}
            </OnboardingCardCounter>
        </OnboardingTaskMarkupWrapper>
    );
};
